import { Pagination, Select, Table } from "antd";
import React, { useState } from "react";
import { ChevronDown, ChevronUp, Filter } from "react-feather";
import CustomAutoComplete from "../../CommonComponents/CustomAutoComplete/CustomAutoComplete";

import "./stylesGamesList.css";

function GamesList() {
  const [showExtraFilters, setShowExtraFilters] = useState(true);

  const gamesSelectorOptions = [
    {
      label: "Provider",
      value: "provider",
      options: [
        { value: "BGaming", label: "BGaming" },
        { value: "Booming", label: "Booming" },
        { value: "IMoon", label: "IMoon" },
        { value: "OddsChecker", label: "OddsChecker" },
        { value: "Action Network", label: "Action Network" },
        { value: "BetQL", label: "BetQL" },
      ],
    },
    {
      label: "Category",
      value: "category",
      options: [
        { value: "Slots", label: "Slots" },
        { value: "Table Games", label: "Table Games" },
        { value: "Live Casino", label: "Live Casino" },
        { value: "Sports", label: "Sports" },
        { value: "Virtual Sports", label: "Virtual Sports" },
        { value: "Poker", label: "Poker" },
      ],
    },
    {
      label: "Status",
      value: "status",
      options: [
        { value: "Active", label: "Active" },
        { value: "Inactive", label: "Inactive" },
        { value: "Hidden", label: "Hidden" },
        { value: "Disabled", label: "Disabled" },
      ],
    },
    {
      label: "Accepted bets",
      value: "acceptedBets",
      options: [
        { value: "Yes", label: "Yes" },
        { value: "No", label: "No" },
      ],
    },
    {
      label: "GGR",
      value: "ggr",
      options: [
        { value: "Yes", label: "Yes" },
        { value: "No", label: "No" },
      ],
    },
    {
      label: "Turnover",
      value: "turnover",
      options: [
        { value: "Yes", label: "Yes" },
        { value: "No", label: "No" },
      ],
    },
    {
      label: "Margin",
      value: "margin",
      options: [
        { value: "Yes", label: "Yes" },
        { value: "No", label: "No" },
      ],
    },
    {
      label: "Net P/L",
      value: "netPL",
      options: [
        { value: "Yes", label: "Yes" },
        { value: "No", label: "No" },
      ],
    },
    {
      label: "Total Stake",
      value: "totalStake",
      options: [
        { value: "Yes", label: "Yes" },
        { value: "No", label: "No" },
      ],
    },
  ];

  const providers = [
    {
      value: "BGaming",
      label: "BGaming",
    },
    {
      value: "Booming",
      label: "Booming",
    },
    {
      value: "IMoon",
      label: "IMoon",
    },
    {
      value: "OddsChecker",
      label: "OddsChecker",
    },
    {
      value: "Action Network",
      label: "Action Network",
    },
    {
      value: "BetQL",
      label: "BetQL",
    },
  ];

  const columns = [
    {
      title: "Provider Name",
      dataIndex: "providerName",
      key: "providerName",
      sorter: (a, b) => a.providerName.localeCompare(b.providerName),
    },
    {
      title: "Game Name",
      dataIndex: "gameName",
      key: "gameName",
      sorter: (a, b) => a.gameName.localeCompare(b.gameName),
    },
    {
      title: "Providers",
      dataIndex: "providers",
      key: "providers",
      sorter: (a, b) => a.providers.localeCompare(b.providers),
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      sorter: (a, b) => a.category.localeCompare(b.category),
    },
    {
      title: "Accepted Bets",
      dataIndex: "acceptedBets",
      key: "acceptedBets",
      sorter: (a, b) => a.providerName.localeCompare(b.providerName),
    },
    {
      title: "GGR",
      dataIndex: "ggr",
      key: "ggr",
      sorter: (a, b) => a.providerName.localeCompare(b.providerName),
      render: (text) => (
        <span className="ggr">
          {text.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          })}
        </span>
      ),
    },
    {
      title: "Turnover",
      dataIndex: "turnover",
      key: "turnover",
      sorter: (a, b) => a.providerName.localeCompare(b.providerName),
      render: (text) => (
        <span className="turnover">
          {text.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          })}
        </span>
      ),
    },
    {
      title: "Margin",
      dataIndex: "margin",
      key: "margin",
      sorter: (a, b) => a.providerName.localeCompare(b.providerName),
    },
    {
      title: "Net P/L",
      dataIndex: "netPL",
      key: "netPL",
      sorter: (a, b) => a.providerName.localeCompare(b.providerName),
      render: (text) => (
        <span className={`net-pl ${text < 0 ? "negative" : "positive"}`}>
          {text.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          })}
        </span>
      ),
    },
    {
      title: "Total Stake",
      dataIndex: "totalStake",
      key: "totalStake",
      sorter: (a, b) => a.providerName.localeCompare(b.providerName),
      render: (text) => (
        <span className="total-stake">
          {text.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          })}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => a.providerName.localeCompare(b.providerName),
      render: (text) => (
        <span className={`status ${text.toLowerCase()}`}>{text}</span>
      ),
    },
  ];

  const dataSource = Array.from({ length: 100 }, (_, index) => ({
    key: (index + 1).toString(),
    providerName: `Provider ${String.fromCharCode(65 + (index % 26))}`,
    gameName: `Game ${index + 1}`,
    providers: Math.floor(Math.random() * 200) + 50,
    category: `Category ${String.fromCharCode(65 + (index % 5))}`,
    acceptedBets: Math.floor(Math.random() * 10000) + 1000,
    ggr: Math.floor(Math.random() * 50000) + 10000,
    turnover: Math.floor(Math.random() * 200000) + 50000,
    margin: `${Math.floor(Math.random() * 30) + 10}%`,
    netPL: Math.floor(Math.random() * 10000) - 5000,
    totalStake: Math.floor(Math.random() * 180000) + 20000,
    status: Math.random() > 0.5 ? "Active" : "Hiden",
  }));

  return (
    <div className="casino-content providers-list">
      <div className="casino-content-header">
        <div className="casino-autocomplete-container">
          <CustomAutoComplete
            placeholder="Search"
            allOptions={providers}
            handleChange={() => {}}
            clearOptions={() => {}}
          />
          <div className="divider"></div>
          <div
            className="filter-buttons"
            onClick={() => setShowExtraFilters(!showExtraFilters)}
          >
            <Filter className="filter-icon" />
            {showExtraFilters ? (
              <ChevronUp className="filter-icon" />
            ) : (
              <ChevronDown className="filter-icon" />
            )}
          </div>
        </div>
      </div>
      <div
        className="casino-selectors"
        style={{ display: showExtraFilters ? "flex" : "none" }}
      >
        {gamesSelectorOptions.map((option) => (
          <div className="casino-selector">
            <span>{option.label}</span>
            <Select
              mode="multiple"
              placeholder="Not Selected"
              onChange={() => {}}
              options={option.options}
            />
          </div>
        ))}
      </div>
      <div
        className="casino-selector-action-buttons"
        style={{ display: showExtraFilters ? "flex" : "none" }}
      >
        <button className="clear">Clear Filters</button>
        <button className="apply">Apply</button>
      </div>
      <div className="providers-list-table-container">
        <Table dataSource={dataSource} columns={columns} scroll={{ x: 1500 }} />
      </div>
    </div>
  );
}

export default GamesList;
